import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createVNode as _createVNode } from "vue"
import _imports_0 from '@/assets/icons/checkmark-circle.svg'
import _imports_1 from '@/assets/navbar-icons/reimbursement.svg'
import _imports_2 from '@/assets/navbar-icons/payroll.svg'


const _hoisted_1 = {
  key: 1,
  class: "flex flex-col"
}
const _hoisted_2 = { key: 0 }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "bg-gray-300 h-px w-full" }, null, -1)
const _hoisted_4 = {
  key: 0,
  class: "flex flex-row items-center justify-between py-2"
}
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "w-20 flex items-center justify-center w-1/12" }, [
  /*#__PURE__*/_createElementVNode("img", { src: _imports_0 })
], -1)
const _hoisted_6 = { class: "flex flex-col w-9/12" }
const _hoisted_7 = { class: "flex flex-row items-center" }
const _hoisted_8 = { class: "inline" }
const _hoisted_9 = { class: "flex items-center justify-center bg-primary text-white rounded-full w-10 h-10" }
const _hoisted_10 = { class: "text-wrap ml-2" }
const _hoisted_11 = { class: "font-semibold" }
const _hoisted_12 = { class: "text-gray-500 italic w-2/12" }
const _hoisted_13 = { key: 1 }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("div", { class: "bg-gray-300 h-px w-full" }, null, -1)
const _hoisted_15 = {
  key: 0,
  class: "flex flex-row bg-green-100 items-start justify-between py-2"
}
const _hoisted_16 = /*#__PURE__*/_createElementVNode("div", { class: "w-20 flex items-center justify-center w-1/12" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    class: "mt-2"
  })
], -1)
const _hoisted_17 = { class: "flex flex-col w-9/12" }
const _hoisted_18 = { class: "flex flex-row items-center" }
const _hoisted_19 = { class: "inline" }
const _hoisted_20 = { class: "flex items-center justify-center bg-primary text-white rounded-full w-10 h-10" }
const _hoisted_21 = { class: "text-wrap ml-2" }
const _hoisted_22 = { class: "font-semibold" }
const _hoisted_23 = /*#__PURE__*/_createTextVNode(" was hired. ")
const _hoisted_24 = { class: "text-gray-500 italic w-2/12" }
const _hoisted_25 = { key: 2 }
const _hoisted_26 = /*#__PURE__*/_createElementVNode("div", { class: "bg-gray-300 h-px w-full" }, null, -1)
const _hoisted_27 = { class: "flex flex-row items-center justify-between py-2" }
const _hoisted_28 = /*#__PURE__*/_createElementVNode("div", { class: "w-20 flex items-center justify-center w-1/12" }, [
  /*#__PURE__*/_createElementVNode("img", { src: _imports_1 })
], -1)
const _hoisted_29 = { class: "flex flex-col w-9/12" }
const _hoisted_30 = { class: "flex flex-row items-center" }
const _hoisted_31 = { class: "inline" }
const _hoisted_32 = { class: "flex items-center justify-center bg-primary text-white rounded-full w-10 h-10" }
const _hoisted_33 = { class: "text-wrap ml-2" }
const _hoisted_34 = { class: "font-semibold" }
const _hoisted_35 = { key: 0 }
const _hoisted_36 = {
  key: 1,
  class: "ml-1"
}
const _hoisted_37 = /*#__PURE__*/_createTextVNode(" a reimbursement for ")
const _hoisted_38 = { class: "font-semibold" }
const _hoisted_39 = { class: "uppercase" }
const _hoisted_40 = { class: "text-gray-500 italic w-2/12" }
const _hoisted_41 = { key: 3 }
const _hoisted_42 = /*#__PURE__*/_createElementVNode("div", { class: "bg-gray-300 h-px w-full" }, null, -1)
const _hoisted_43 = { class: "flex flex-row items-center justify-between py-2" }
const _hoisted_44 = /*#__PURE__*/_createElementVNode("div", { class: "w-20 flex items-center justify-center w-1/12" }, [
  /*#__PURE__*/_createElementVNode("img", { src: _imports_2 })
], -1)
const _hoisted_45 = { class: "flex flex-col w-9/12" }
const _hoisted_46 = { class: "text-wrap ml-2" }
const _hoisted_47 = /*#__PURE__*/_createTextVNode(" Payroll period created for ")
const _hoisted_48 = /*#__PURE__*/_createTextVNode(" to ")
const _hoisted_49 = /*#__PURE__*/_createTextVNode(". ")
const _hoisted_50 = { class: "text-gray-500 italic w-2/12" }
const _hoisted_51 = { key: 4 }
const _hoisted_52 = /*#__PURE__*/_createElementVNode("div", { class: "bg-gray-300 h-px w-full" }, null, -1)
const _hoisted_53 = { class: "flex flex-row items-center bg-green-100 justify-between py-2" }
const _hoisted_54 = /*#__PURE__*/_createElementVNode("div", { class: "w-20 flex items-center justify-center w-1/12" }, [
  /*#__PURE__*/_createElementVNode("img", { src: _imports_2 })
], -1)
const _hoisted_55 = { class: "flex flex-col w-9/12" }
const _hoisted_56 = { class: "text-wrap ml-2" }
const _hoisted_57 = ["onClick"]
const _hoisted_58 = /*#__PURE__*/_createTextVNode("Payroll period from ")
const _hoisted_59 = /*#__PURE__*/_createTextVNode(" to ")
const _hoisted_60 = /*#__PURE__*/_createTextVNode(" was paid on ")
const _hoisted_61 = /*#__PURE__*/_createTextVNode(". ")
const _hoisted_62 = { class: "text-gray-500 italic w-2/12" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Spinner = _resolveComponent("Spinner")!
  const _component_ErrorState = _resolveComponent("ErrorState")!
  const _component_EmptyState = _resolveComponent("EmptyState")!
  const _component_DateFormatter = _resolveComponent("DateFormatter")!

  return (_ctx.loading)
    ? (_openBlock(), _createBlock(_component_Spinner, {
        key: 0,
        class: "mt-4"
      }))
    : (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (_ctx.error)
          ? (_openBlock(), _createBlock(_component_ErrorState, {
              key: 0,
              class: "mt-8"
            }))
          : _createCommentVNode("", true),
        (!_ctx.error && _ctx.timeline.length === 0)
          ? (_openBlock(), _createBlock(_component_EmptyState, {
              key: 1,
              name: "events"
            }))
          : _createCommentVNode("", true),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.timeline, (element, i) => {
          return (_openBlock(), _createElementBlock("div", { key: i }, [
            (element.event_type === 'job_candidate_stage_change')
              ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                  _hoisted_3,
                  (element.staff)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                        _hoisted_5,
                        _createElementVNode("div", _hoisted_6, [
                          _createElementVNode("div", _hoisted_7, [
                            _createElementVNode("div", _hoisted_8, [
                              _createElementVNode("div", _hoisted_9, _toDisplayString(element.staff.first_name[0] + element.staff.last_name[0]), 1)
                            ]),
                            _createElementVNode("p", _hoisted_10, [
                              _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.convertString(
                    element.staff.first_name + " " + element.staff.last_name
                  )), 1),
                              _createTextVNode(" was moved to " + _toDisplayString(element.sourceable.job_stage.stage.name) + ". ", 1)
                            ])
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_12, " • " + _toDisplayString(_ctx.timeAgo(element.updated_at)), 1)
                      ]))
                    : _createCommentVNode("", true)
                ]))
              : (element.event_type === 'job_candidate_hired')
                ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                    _hoisted_14,
                    (element.staff)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                          _hoisted_16,
                          _createElementVNode("div", _hoisted_17, [
                            _createElementVNode("div", _hoisted_18, [
                              _createElementVNode("div", _hoisted_19, [
                                _createElementVNode("div", _hoisted_20, _toDisplayString(element.staff.first_name[0] + element.staff.last_name[0]), 1)
                              ]),
                              _createElementVNode("p", _hoisted_21, [
                                _createElementVNode("span", _hoisted_22, _toDisplayString(_ctx.convertString(
                    element.staff.first_name + " " + element.staff.last_name
                  )), 1),
                                _hoisted_23
                              ])
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_24, " • " + _toDisplayString(_ctx.timeAgo(element.updated_at)), 1)
                        ]))
                      : _createCommentVNode("", true)
                  ]))
                : (element.sourceable_type === 'Reimbursement')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                      _hoisted_26,
                      _createElementVNode("div", _hoisted_27, [
                        _hoisted_28,
                        _createElementVNode("div", _hoisted_29, [
                          _createElementVNode("div", _hoisted_30, [
                            _createElementVNode("div", _hoisted_31, [
                              _createElementVNode("div", _hoisted_32, _toDisplayString(element.staff.first_name[0] + element.staff.last_name[0]), 1)
                            ]),
                            _createElementVNode("p", _hoisted_33, [
                              _createElementVNode("span", _hoisted_34, _toDisplayString(_ctx.convertString(
                      element.staff.first_name + " " + element.staff.last_name
                    )), 1),
                              (element.sourceable.status === 'pending')
                                ? (_openBlock(), _createElementBlock("span", _hoisted_35, " requested "))
                                : (_openBlock(), _createElementBlock("span", _hoisted_36, _toDisplayString(element.sourceable.status), 1)),
                              _hoisted_37,
                              _createElementVNode("span", _hoisted_38, _toDisplayString(_ctx.convertString(
                      element.talent.first_name + " " + element.talent.last_name
                    )), 1),
                              _createTextVNode(" for $" + _toDisplayString((element.sourceable.original_amount / 100).toLocaleString(
                    undefined,
                    { minimumFractionDigits: 2, maximumFractionDigits: 2 }
                  )) + " ", 1),
                              _createElementVNode("span", _hoisted_39, _toDisplayString(element.sourceable.currency), 1)
                            ])
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_40, " • " + _toDisplayString(_ctx.timeAgo(element.updated_at)), 1)
                      ])
                    ]))
                  : (
          element.sourceable_type === 'PayrollPeriod' &&
          element.event_type === 'creation'
        )
                    ? (_openBlock(), _createElementBlock("div", _hoisted_41, [
                        _hoisted_42,
                        _createElementVNode("div", _hoisted_43, [
                          _hoisted_44,
                          _createElementVNode("div", _hoisted_45, [
                            _createElementVNode("p", _hoisted_46, [
                              _hoisted_47,
                              _createVNode(_component_DateFormatter, {
                                date: element.sourceable.start_date
                              }, null, 8, ["date"]),
                              _hoisted_48,
                              _createVNode(_component_DateFormatter, {
                                date: element.sourceable.end_date
                              }, null, 8, ["date"]),
                              _hoisted_49
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_50, " • " + _toDisplayString(_ctx.timeAgo(element.updated_at)), 1)
                        ])
                      ]))
                    : (element.event_type === 'invoice_payment')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_51, [
                          _hoisted_52,
                          _createElementVNode("div", _hoisted_53, [
                            _hoisted_54,
                            _createElementVNode("div", _hoisted_55, [
                              _createElementVNode("p", _hoisted_56, [
                                _createElementVNode("span", {
                                  class: "cursor-pointer",
                                  onClick: ($event: any) => (_ctx.$router.push(`/payroll/${element.sourceable.id}`))
                                }, [
                                  _hoisted_58,
                                  _createVNode(_component_DateFormatter, {
                                    date: element.sourceable.start_date
                                  }, null, 8, ["date"]),
                                  _hoisted_59,
                                  _createVNode(_component_DateFormatter, {
                                    date: element.sourceable.end_date
                                  }, null, 8, ["date"])
                                ], 8, _hoisted_57),
                                _hoisted_60,
                                _createVNode(_component_DateFormatter, {
                                  date: element.updated_at
                                }, null, 8, ["date"]),
                                _hoisted_61
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_62, " • " + _toDisplayString(_ctx.timeAgo(element.updated_at)), 1)
                          ])
                        ]))
                      : _createCommentVNode("", true)
          ]))
        }), 128))
      ]))
}